import { getReq } from ".";

export const getUserDetails = () => {
  return getReq(`/me`, {}, true, true);
};

export const getStudent = (studentId) => {
  return getReq(`/students/${studentId}`);
};
